import { useContext } from "react";
import { InviteAudiologistContext } from "./invite-audiologist-context";

export const useInviteAudiologistContext = () => useContext(InviteAudiologistContext);
